<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới người sử dụng</strong>
                    </div>
                    <b-form @submit.prevent="save" autocomplete="off">
                        <!-- disable autocomplete -->
                        <input autocomplete="blah blah" style="opacity: 0;position: absolute;">
                        <input type="text" name="username" autocomplete="blah blah" style="opacity: 0;position: absolute;">
                        <input type="email" name="email" autocomplete="blah blah" style="opacity: 0;position: absolute;">
                        <input type="password" name="password" autocomplete="blah blah" style="opacity: 0;position: absolute;">
                        <!-- disable autocomplete -->
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="username"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" id="username"
                                                  v-model="$v.user.username.$model"
                                                  :state="$v.user.username.$dirty? !$v.user.username.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.user.username.required">
                                        Vui lòng nhập tên tài khoản
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.user.username.usernamePattern">
                                        Tên tài khoản chỉ được phép sử dụng chữ cái và số. Dấu chấm(.), dấu gạch ngang (-) hoặc dấu gạch dưới (_) dùng để phân cách
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.user.username.isUnique">
                                        Tên tài khoản đã tồn tại
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" style="display: none"
                                                  v-model="$v.user.unitId.$model"
                                                  :state="$v.user.unitId.$error ? false : null">
                                    </b-form-input>
                                    <unit-tree v-model="$v.user.unitId.$model"></unit-tree>
                                    <b-form-invalid-feedback>
                                        Vui lòng nhập đơn vị
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Họ tên:"
                                              label-for="fullName"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="fullName" v-model="user.fullName">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="fullNameFeedback">
                                        Vui lòng nhập họ tên
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Mật khẩu:"
                                              label-for="password"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="password" id="password"
                                                  v-model="$v.user.password.$model"
                                                  @input="$v.user.password.$touch"
                                                  :state="$v.user.password.$dirty? !$v.user.password.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.user.password.required">
                                        Vùi lòng nhập mật khẩu
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.user.password.minLength">
                                        Mật khẩu phải có ít nhất 8 ký tự
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="$v.user.password.minLength && !$v.user.password.passwordPattern">
                                        Mật khẩu phải chứa chữ hoa, chữ thường, số và ký tự đặc biệt
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Nhập lại mật khẩu:"
                                              label-for="passwordConfirmation"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="password" id="passwordConfirmation"
                                                  v-model="$v.user.passwordConfirmation.$model"
                                                  @input="$v.user.passwordConfirmation.$touch"
                                                  :state="$v.user.passwordConfirmation.$dirty? !$v.user.passwordConfirmation.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.user.passwordConfirmation.required">
                                        Vui lòng nhập lại mật khẩu
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="$v.user.passwordConfirmation.required && !$v.user.passwordConfirmation.sameAsPassword">
                                        Mật khẩu không khớp
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Số điện thoại:"
                                              label-for="phoneNumber"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="">
                                    <b-form-input type="tel" id="phoneNumber" maxlength="20"
                                                  v-model="user.phoneNumber">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Email:"
                                              label-for="email"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="">
                                    <b-form-input type="email" id="email"
                                                  v-model="user.email">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Nhóm tài khoản người dùng:"
                                              label-for="roles"
                                              :label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="">
                                    <b-form-checkbox-group v-model="user.roleIds" class="checkbox-group">
                                        <b-form-checkbox v-for="(role, index) in listRoles" :key="role.id" :value="role.id" v-bind:style="{ width: index % 2 == 0 ? 61.5 + '%' : 'auto'}">{{ role.text }}</b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
        <b-col md="6">
            <b-form-group label="Đơn vị quản lý:"
                          :label-cols-md="4"
                          :horizontal="true"
                          label-align="left">
                <select2 v-model="syncSourceType" :options="listSyncSourceTypes"
                         style="width:100%"
                         placeholder="--- Chọn ---"
                         allowClear="true"></select2>
            </b-form-group>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="6">
            <b-form-group :label-cols-md="4"
                          :horizontal="true"
                          label-align="left">
                <unit-tree ref="manageUnitsTree" :syncSourceType="syncSourceType" multiple @select="selectUnit" @deselect="deselectUnit" placeholder="--- Thêm đơn vị quản lý ---"></unit-tree>
            </b-form-group>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="6">
            <b-form-group label=""
                          :label-cols-md="4"
                          :horizontal="true"
                          label-align="left">
                <b-button type="button" variant="primary" @click="addManageUnits">Thêm</b-button>
            </b-form-group>
        </b-col>
    </b-row>-->
                        <br />
                        <br />
                        <b-row>
                            <b-col md="8">
                                <h2>Danh sách đơn vị quản lý</h2>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="5"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="syncSourceType" :options="listSyncSourceTypes"
                                             style="width:100%"
                                             placeholder="--- Chọn ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị quản lý:"
                                              :label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree ref="manageUnitsTree" :syncSourceType="syncSourceType" multiple @select="selectUnit" @deselect="deselectUnit" placeholder="--- Thêm đơn vị quản lý ---"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col md="2">
                                <b-button type="button" variant="primary" @click="addManageUnits">Thêm</b-button>
                            </b-col>
                        </b-row>
                        <b-grid :items="user.manageUnits"
                                :gridOptions="gridOptions">
                            <template v-slot:cell(syncSourceType)="row">
                                {{ listSyncSourceTypes.find(x => x.id == row.value).text }}
                            </template>
                            <!--<template v-slot:actions>
            <unit-tree multiple @select="selectUnit" @deselect="deselectUnit" placeholder="--- Thêm đơn vị quản lý ---"></unit-tree>
        </template>-->
                            <template v-slot:cell(_actions)="row">
                                <b-button size="sm" @click.stop="removeUnit(row.item, row.index, $event.target)" class="mr-1" variant="danger" title="xóa">
                                    Xoá
                                </b-button>
                            </template>
                        </b-grid>

                        <div class="text-center">
                            <b-button type="submit" v-if="authorize(['ManageUser'])" variant="primary">Lưu</b-button>

                            <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    const passwordPattern = helpers.regex('passwordPattern', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/)
    const usernamePattern = helpers.regex('usernamePattern', /^[a-zA-Z0-9]+([-_.]?[a-zA-Z0-9])*$/)
    import services from '@/utils/services'

    var isUsernameUnique = _.debounce((value, resolve) => {
        services.get(`users/user-name-unique?name=${value}`, null, { showLoading: false }).done((result) => resolve(result));
    }, 500);

    export default {
        name: 'CreateUser',
        mixins: [validationMixin, mixins],
        data() {
            return {
                listRoles: [],
                user: {
                    username: null,
                    password: null,
                    passwordConfirmation: null,
                    unitId: null,
                    fullName: null,
                    email: null,
                    phoneNumber: null,
                    roleIds: [],
                    manageUnits: []
                },
                gridOptions: {
                    fields: [
                        { key: 'syncSourceType', label: 'Phần mềm quản lý', sortable: true, sortDirection: 'asc' },
                        { key: 'unitCode', label: 'Mã đơn vị', sortable: true, sortDirection: 'asc' },
                        { key: 'unitName', label: 'Tên đơn vị', sortable: true },
                    ]
                },
                editing: false,
                selectedManageUnits: [],
                syncSourceType: 1
            }
        },
        validations: {
            user: {
                username: {
                    required,
                    isUnique(value) {
                        return new Promise((resolve) => {
                            if (!value) {
                                resolve(true);
                            }
                            else {
                                isUsernameUnique(value, resolve);
                            }
                        });
                    },
                    usernamePattern
                },
                password: { required, minLength: minLength(8), passwordPattern },
                passwordConfirmation: { required, sameAsPassword: sameAs('password') },
                unitId: { required },
            },
        },
        computed: {
            ...mapState({
                listSyncSourceTypes: (state) => state.common.listSyncSourceTypes.filter(x => x.id != 2)
            })
        },
        created() {
            var vm = this;
            this.$services.get('lookup/roles').done((response) => vm.listRoles = response);
        },
        methods: {
            cancel() {
                this.$router.push({ path: '.' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (!vm.$v.$invalid) {
                    vm.$services.post('users', vm.user).done((id) => {
                        vm.$toastr.s('Tạo mới người dùng thành công');
                        vm.cancel();
                    });
                }
            },
            selectUnit(unit) {
                //if (unit && this.user.manageUnits.find(x => x.unitId == unit.id) == null) {
                //    this.user.manageUnits.push({
                //        unitId: unit.id,
                //        unitCode: unit.code,
                //        unitName: unit.label
                //    });
                //}
                this.selectedManageUnits.push({
                    unitId: unit.id,
                    unitCode: unit.code,
                    unitName: unit.label,
                    syncSourceType: this.syncSourceType
                });
            },
            deselectUnit(unit) {
                //this.user.manageUnits.remove(this.user.manageUnits.find(x => x.unitId == unit.id));
                this.selectedManageUnits.remove(this.selectedManageUnits.find(x => x.unitId == unit.id));
            },
            addManageUnits() {
                for (var i = 0; i < this.selectedManageUnits.length; i++) {
                    if (this.user.manageUnits.find(x => x.unitId == this.selectedManageUnits[i].unitId) == null) {
                        this.user.manageUnits.push(this.selectedManageUnits[i]);
                    }
                }

                this.$refs.manageUnitsTree.resetTree();
                this.selectedManageUnits = [];
            },
            removeUnit(unit) {
                this.user.manageUnits.remove(unit);
            }
        }
    }
</script>
<style scoped>
</style>
